import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';

/**
 * Einfache Pipe-Implementierung um das Ersetzen von Platzhaltern in Texten zu ermöglichen.
 * Anwendungsfall sind i18n-Messages in denen Platzhalter durch dynamische Werte (z.B. die Währung des Unternehmens) ersetzt werden.
 *
 * Beispiel:
 *  - customPlaceholder:'{currency}':data?.companyCurrency      Ersetz das Vorkommen von '{currency}' durch den übergebenen Wert
 *
 * @author: mgru
 */
@Pipe({
    name: 'customPlaceholder'
})
export class CustomPlaceholderPipe implements PipeTransform {

    private languageSubscription: Subscription;

    private pattern;
    private target;

    constructor(private languageService: LanguageService) {
    }

    transform(value: string, pattern: string, target: string) {

        if (pattern) {
            this.pattern = pattern;
        }

        if (target) {
            this.target = target;
        }

        if (value) {
            return value.replace(pattern, target);
        }
        return null;
    }

    ngOnDestroy() {
        if (this.languageSubscription) this.languageSubscription.unsubscribe();
    }
}
